const SPLIT_RE = /[,;]+/;

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const MAX_NOTIFY_RECIPIENTS = 25;

/**
 * Parses `NEXT_PUBLIC_*_NOTIFY_EMAIL` values that may list several inboxes
 * (comma- or semicolon-separated). Used on the client (inlined env) and on the server.
 */
export function parseNotifyEmailList(raw: string | undefined): string[] {
  if (!raw?.trim()) return [];
  const seen = new Set<string>();
  const out: string[] = [];
  for (const part of raw.split(SPLIT_RE)) {
    const e = part.trim().toLowerCase();
    if (!e || seen.has(e)) continue;
    if (!emailPattern.test(e)) continue;
    seen.add(e);
    out.push(e);
    if (out.length >= MAX_NOTIFY_RECIPIENTS) break;
  }
  return out;
}

/** First env string in order that yields at least one valid address. */
export function parseNotifyEmailListFromEnvChain(
  ...raws: (string | undefined)[]
): string[] {
  for (const raw of raws) {
    const list = parseNotifyEmailList(raw);
    if (list.length > 0) return list;
  }
  return [];
}

export function buildContactApiAllowedNotifyRecipients(): Set<string> {
  const set = new Set<string>();
  for (const e of parseNotifyEmailList(process.env.NEXT_PUBLIC_CONTACT_NOTIFY_EMAIL)) {
    set.add(e);
  }
  for (const e of parseNotifyEmailList(process.env.NEXT_PUBLIC_DIGITAL_REPORT_NOTIFY_EMAIL)) {
    set.add(e);
  }
  return set;
}
